export default __webpack_public_path__ + "static/media/cover_disco.f51bc7f7.png";